import GetCustomersRequestModelBase from '../_generated/modelBases/get-customers-request-model-base';

export default class GetCustomersRequestModel extends GetCustomersRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
